import slice from './card.slice';
export default slice.reducer;
